import { useState } from "react";

import { publicEnv } from "../app/env";
import { useTrafficStore } from "../stores/useTrafficStore";

const countStops = [1, 10, 50, 250, 1_000, 10_000, 100_000] as const;

function nearestStopIndex(count: number): number {
  let bestIndex = 0;
  let bestDistance = Number.POSITIVE_INFINITY;
  countStops.forEach((stop, index) => {
    const distance = Math.abs(Math.log10(stop) - Math.log10(count));
    if (distance < bestDistance) {
      bestDistance = distance;
      bestIndex = index;
    }
  });
  return bestIndex;
}

export function MockTrafficPanel() {
  const count = useTrafficStore((state) => state.driverCount);
  const setDriverCount = useTrafficStore((state) => state.setDriverCount);
  const [open, setOpen] = useState(false);

  if (
    publicEnv.VITE_REALTIME_MODE !== "mock" ||
    publicEnv.VITE_APP_ENV === "production"
  ) {
    return null;
  }

  return (
    <aside className={`mock-panel ${open ? "mock-panel--open" : ""}`}>
      <button
        className="mock-panel__toggle"
        type="button"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        <span className="live-dot" aria-hidden="true" />
        MOCK TRAFFIC
      </button>
      {open ? (
        <div className="mock-panel__body">
          <label htmlFor="mock-count">Simulated global drivers</label>
          <strong>{count.toLocaleString()}</strong>
          <input
            id="mock-count"
            type="range"
            min="0"
            max={countStops.length - 1}
            step="1"
            value={nearestStopIndex(count)}
            onChange={(event) => {
              const next = countStops[Number(event.target.value)];
              if (next !== undefined) setDriverCount(next);
            }}
          />
          <div className="mock-panel__ticks" aria-hidden="true">
            <span>1</span>
            <span>100K</span>
          </div>
          <p>
            Development-only controls. Every visible car is a labeled mock
            identity.
          </p>
        </div>
      ) : null}
    </aside>
  );
}
